// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import gitinfos from "../../gitinfos.json"
import appPackage from "../../package.json"

export const environment = {
  appVersion: appPackage.version,
  githash: gitinfos.hash,
  gitcomment: gitinfos.comment,
  production: false,
  useEmulators: false,
  hmr: false,
  backend: true,
  webClientId:
    "356724608836-s8cbort54m83s7k53na35sond46snths.apps.googleusercontent.com",
  firebase: {
    apiKey: "AIzaSyDVvRBWAIDYWhd9HpasGaId0Rzdg4yesp0",
    authDomain: "extension-services-dev.firebaseapp.com",
    projectId: "extension-services-dev",
    storageBucket: "extension-services-dev.appspot.com",
    messagingSenderId: "356724608836",
    appId: "1:356724608836:web:aa5b08006c0b936b82d111",
    measurementId: "G-X7C6C8V3T0"
  },
  shopifyDomain: "ac14e2-d6",
  shopifyAccessToken: "dc1282053b1d2bbad0d10bd4c409922a"
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
